import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function ChildHomePage() {
  const { user } = useAuth();
  const navigate = useNavigate();

  return (
    <div>
      <div className="card hero-card" style={{ marginBottom: 20 }}>
        <div className="hero-title">Hey {user?.name || 'there'} 👋</div>
        <div className="hero-subtitle">
          This is your child app space. Stay safe, stay connected, and chat with your parent anytime.
        </div>
        <div className="hero-actions">
          <button className="btn btn-primary" onClick={() => navigate('/child/chat')}>💬 Open Chat</button>
          <button className="btn btn-outline" onClick={() => navigate('/child/help')}>🤖 Ask AI Guide</button>
          <button className="btn btn-outline" onClick={() => navigate('/child/permissions')}>🛡️ Manage Permissions</button>
        </div>
      </div>

      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-icon blue">🔒</div>
          <div className="stat-info">
            <div className="stat-value">Safe</div>
            <div className="stat-label">Security Status</div>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-icon green">💬</div>
          <div className="stat-info">
            <div className="stat-value">Live</div>
            <div className="stat-label">Parent Chat</div>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-icon purple">🤖</div>
          <div className="stat-info">
            <div className="stat-value">Ready</div>
            <div className="stat-label">AI Helper</div>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="card-header">
          <div className="card-title">✨ Quick Tips</div>
        </div>
        <div style={{ display: 'grid', gap: 10, fontSize: 13, color: 'var(--text-secondary)' }}>
          <div>• Use chat to ask your parent for help quickly.</div>
          <div>• Keep permissions enabled for location and safety features.</div>
          <div>• Open AI Guide to understand how every feature works.</div>
          <div>• If something feels wrong, contact your parent immediately.</div>
        </div>
      </div>
    </div>
  );
}
